var lib_core = require("lib-core");

var ArcCenterHandleView = require("./arcCenterHandleView");
var ArcFocalHandleView = require("./arcFocalHandleView");
var PathSegmentView = require("./pathSegmentView");

var PathArcSegmentView = function (gui, interactionModel, parentGroup, layers, config, parent) {
    var self = this;
    PathSegmentView.apply(this, arguments);

    if(self.layers.interaction){
        self.C = new ArcCenterHandleView(self.gui, this.interactionModel.C(), self.parentGroup, self.layers);
        self.F = new ArcFocalHandleView(self.gui, this.interactionModel.F(), self.parentGroup, self.layers);
        self.Fp = new ArcFocalHandleView(self.gui, this.interactionModel.Fp(), self.parentGroup, self.layers);
    }
};

lib_core.inherit(PathArcSegmentView, PathSegmentView);
PathArcSegmentView.$class = "PathArcSegmentView";
module.exports = PathArcSegmentView;

